// extracted by mini-css-extract-plugin
export default {"content":"SessionLoadingModal_content__rHyVq","text":"SessionLoadingModal_text__ngKAx"};